import { render, staticRenderFns } from "./payFooter.vue?vue&type=template&id=7d61a3e4&scoped=true"
import script from "./payFooter.vue?vue&type=script&lang=js"
export * from "./payFooter.vue?vue&type=script&lang=js"
import style0 from "./payFooter.vue?vue&type=style&index=0&id=7d61a3e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d61a3e4",
  null
  
)

export default component.exports